import { ca } from '@cian/analytics';

import { IPromo } from '../../../types/promosPage';

interface ITrackCoPromoClickParams {
  promo: IPromo;
}

export const trackCoPromoClick = ({ promo }: ITrackCoPromoClickParams) => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'BlackFriday',
    name: 'oldevent',
    label: 'exclusive_promos',
    page: {
      extra: {
        promo_id: promo.providerPromoId,
      },
    },
  });
};
